import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Utils & misc
import cn from '../../utils/cn';

import style from './Toaster.module.css';

const Toast = ({
  title, content, color, closePicto, isSelfClosing, onToastClose, selfClosingTiming,
}) => {
  useEffect(() => {
    let timeout = null;
    if (isSelfClosing) {
      timeout = setTimeout(onToastClose, selfClosingTiming);
    }

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className={cn([style.toast, style[color], style.sideEntrance])}>
      <button className={style.closeBtn} type="button" onClick={onToastClose}>
        <i className={closePicto} />
      </button>
      <p className={style.title}>{title}</p>
      <p className={style.content}>{content}</p>
      <span
        className={cn([style.bottomBorder, isSelfClosing ? style.borderAnimation : null])}
        style={{ animationDuration: `${selfClosingTiming}ms` }}
      />
    </div>
  );
};

Toast.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  closePicto: PropTypes.string.isRequired,
  onToastClose: PropTypes.func.isRequired,
  isSelfClosing: PropTypes.bool,
  color: PropTypes.oneOf(['primary', 'secondary', 'accent', 'success', 'error', 'warning', 'grey']),
  selfClosingTiming: PropTypes.number,
};

Toast.defaultProps = {
  isSelfClosing: false,
  color: 'grey',
  selfClosingTiming: 3000,
};

export default Toast;
